var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item"},[_c('svg-icon',{attrs:{"iconClass":"ic_download","className":"icon"}}),_c('a',{staticClass:"i_body_l",attrs:{"href":_vm.item.FileURL,"target":"_blank"}},[_vm._v(_vm._s(_vm.item.FileName))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }